
import React from 'react'
import styles from './footer.scss';

const Footer = () => (
        <footer>
            <div className="row" style={{marginLeft:'0px',marginRight:'0px'}}>
                <div className="col-lg-12 text-center">
                    <p className="copyright-text">
                        <a className="privacy-link" href="https://dcac.wdm.wartsila.com/link.ashx?Action=Download&vault=2c278c26-ecd6-43ad-8d51-69151be0294a&objectGUID=A5E50CAF-F728-4A99-9B7F-E56C5D8E110D&fileGUID=1BC43884-FD3D-4B9E-BEF0-2EB4FFF19492" target="_blank">
                        Privacy notice<img src="/images/link.png" width="15" />
                        </a>
                        Copyright © Wärtsilä
                    </p>
                </div>
            </div>
        </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer.js